/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';

const displayName = 'DetailInvoiceSend';
const propTypes = {};
const defaultProps = {}

export default { displayName, propTypes, defaultProps };
